// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconTablesRooms = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M7.37 12.368h-1.9l-1.08-5.95a.499.499 0 00-.98.18l1.14 6.26-1.13 4.52c-.07.27.1.54.36.61.04.01.08.01.12.01.22 0 .43-.15.48-.38l1.06-4.25h1.93c.36 0 .66.29.66.66v3.47c0 .28.22.5.5.5s.5-.22.5-.5v-3.47c-.01-.92-.75-1.66-1.66-1.66zM20.58 17.368l-1.13-4.52 1.14-6.26a.499.499 0 00-.4-.58.507.507 0 00-.58.4l-1.08 5.95h-1.9c-.91 0-1.66.74-1.66 1.66v3.47c0 .28.22.5.5.5s.5-.22.5-.5v-3.47c0-.36.29-.66.66-.66h1.92l1.06 4.25c.06.23.26.38.48.38.04 0 .08 0 .12-.01.27-.07.44-.34.37-.61zM16.04 9.888c.28 0 .5-.22.5-.5s-.22-.5-.5-.5h-8.1c-.28 0-.5.22-.5.5s.22.5.5.5h3.55v7.6c0 .28.22.5.5.5s.5-.22.5-.5v-7.6h3.55z"
      fill="#506482"
    />
  );
export default SvgIconTablesRooms;
